import React from 'react'
import Head from 'next/head'

import BasePage from 'modules/marketplace/layout/components/BasePage'
import LegalPageContainer from 'modules/website/components/LegalPageContainer'
import Markdown from 'components/Markdown'

const content = `
# Privacy Policy

Fieldfolio Pty Ltd (in this Privacy Policy, referred to as "Fieldfolio" or "We") collects the following information of persons who use the Fieldfolio Service (as defined in the Terms of Service) or otherwise communicate with Fieldfolio:
- information about the use of the Fieldfolio Service, including but not limited to pages visited, browser(s) used and operating system(s) used; and
- information voluntarily entered into, uploaded or posted to the Fieldfolio Service, or otherwise provided to Fieldfolio, including but not limited to personal names, company names, business numbers, trade references, billing addresses, shipping addresses, email addresses (including of wholesalers, retailers, sellers, buyers, reps and staff users), product data, customer data and order data,
(together, “Personal Information”).

We may:
- use Personal Information to supply the Fieldfolio Service;
- use Personal Information to provide users of the Fieldfolio Service with information about the features and benefits of the Fieldfolio Service from time to time, offers, promotions, and other goods or services;
- disclose Personal Information to our related bodies corporate, service providers and/or business partners;
- disclose Personal Information as required by law or where it is necessary to take action regarding any unauthorised or illegal activity.

## Browser cookies

A cookie is a small amount of data, which often includes an anonymous unique identifier, that is sent to your browser from a web site's computers and stored on your computer's hard drive.

Cookies are required to use the the Fieldfolio Service properly.
`

// TODO: add getStaticProps for static rendering
const PrivacyPage = () => (
  <>
    <Head>
      <title>Privacy Policy · Fieldfolio</title>
      <link rel="canonical" href={`${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/privacy`} />
    </Head>
    <BasePage hasMarketingFooter>
      <LegalPageContainer>
        <Markdown source={content} />
      </LegalPageContainer>
    </BasePage>
  </>
)

export default PrivacyPage
